export type HomePathUser = {
  is_admin?: boolean;
  doctor?: unknown;
} | null | undefined;

/**
 * Where a signed-in user should land. /admin-dashboard is admin-only;
 * sending anyone else there renders a blank layout (the guard redirects
 * to the same path).
 */
export function defaultHomePath(user: HomePathUser): string {
  if (user?.doctor) return '/doctor-dashboard';
  if (user?.is_admin) return '/admin-dashboard';
  return '/patients';
}
